import React, { useEffect, useState } from "react";
import FadeIn from "react-fade-in/lib/FadeIn";
import Lottie from "react-lottie";
import { Button, Col, FormGroup, Input, Label, Modal, ModalBody, ModalHeader, Row } from "reactstrap";
import * as accessDenied from "../../Login/accessDenied.json";
import * as LoadAccept from "../../TESTPage/loadAccept.json";
import axios from "axios";
import { GetCookieData, GetCookieToken } from "../../Cookie/GetCookie";
import dayjs from "dayjs";
import { FetchAxiosGet } from "../../../api/axios";

function ModalAcceptBorrowTable(props) {
    const baseURL = process.env.REACT_APP_API_CORS;
    const token = GetCookieToken("userToken");
    const user = GetCookieData("userData");
    const { allTaskOption, dataGroup, acceptBorrow, handleToggleModaAcceptBorrow, acceptRowBorrow, getBorrowDataTable, checkAllSubmitEquipment } = props
    const [acceptData, setAcceptData] = useState({
        user_id_allot: null,
        user_name_allot: null,
        users_id_use: null,
        users_name_use: null,
    })
    const [rfId_allot, setRrfId_allot] = useState(null)
    const [rfId_borrow, setRfId_allot] = useState(null)
    const [selectId, setSelectId] = useState(1)

    dayjs.locale("th")

    const showDateAndTime = (dateItem) => {
        return `${dayjs.utc(dateItem).add(543, "year").format("DD/MM/YYYY")}  ${dayjs.utc(dateItem).format("HH:mm")}`
    }
    return (
        <Modal
            size="md"
            // size="lg"
            centered
            isOpen={acceptBorrow}
            toggle={handleToggleModaAcceptBorrow}
        >
            <ModalBody>
                <Row>
                    <Col xxl={12} className="d-flex justify-content-center">
                        <h1 style={{ whiteSpace: "nowrap" }}>{allTaskOption}</h1>
                    </Col>
                    <Col xxl={12} className="d-flex justify-content-center mt-4">
                        <div
                            className="p-4"
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                borderRadius: "50%",
                                height: "150px",
                                width: "150px",
                                border: "5px solid black",
                            }}
                        >
                            <FadeIn>
                                {dataGroup.task === "accept" || dataGroup.task === "return" || checkAllSubmitEquipment ?
                                    <Lottie
                                        options={{
                                            loop: true,
                                            autoplay: true,
                                            animationData: LoadAccept,
                                            rendererSettings: {
                                                preserveAspectRatio: "xMidYMid slice",
                                            },
                                        }}
                                        width={180}
                                    />
                                    :
                                    <Lottie
                                        options={{
                                            loop: true,
                                            autoplay: true,
                                            animationData: accessDenied.default,
                                            rendererSettings: {
                                                preserveAspectRatio: "xMidYMid slice",
                                            },
                                        }}
                                        width={180}
                                        height={100}
                                    />
                                }

                            </FadeIn>
                        </div>
                    </Col>
                    <Col className="mt-4" xxl={12}>
                        <Row>
                            <Col xxl={6} className="d-flex justify-content-end">
                                <Button size="lg" color="success" onClick={async () => {
                                    checkAllSubmitEquipment ?
                                        acceptRowBorrow(checkAllSubmitEquipment) 
                                        : await acceptRowBorrow(dataGroup.task, dataGroup.id, dataGroup.equipment_id, dataGroup.users_id_borrow, dataGroup.users_name_borrow, dataGroup.date_borrow, dataGroup.remark_borrow, dataGroup.users_id_returner, dataGroup.users_name_returner, dataGroup.date_return, dataGroup.user_id_allot, dataGroup.user_name_allot, dataGroup.user_id_repatriate, dataGroup.user_name_repatriate)
                                }}>
                                    {dataGroup.task === "accept" ? "ตกลง" : "ตกลง"}
                                </Button>
                            </Col>
                            <Col
                                xxl={6}
                                onClick={handleToggleModaAcceptBorrow}
                                className="d-flex justify-content-start"
                            >
                                <Button size="lg" color="danger">
                                    ปิด
                                </Button>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </ModalBody>
        </Modal>
    )
}

export default ModalAcceptBorrowTable